import { createContext, useContext } from 'react';
import { ReflectiveInjector } from 'injection-js';
import { AgentCaseStore } from './mesh/stores/AgentCaseStore';
import { BidCaseStore } from './mesh/stores/BidCaseStore';
import { AdminStore } from './mesh/stores/AdminStore';
import { GeneralStore } from './mesh/stores/GeneralStore';
import { InsightsStore } from './mesh/stores/InsightsStore';
import { SesamStore } from './mesh/stores/SesamStore';

const generalStore = new GeneralStore();
const insightsStore = new InsightsStore();
const bidCaseStore = new BidCaseStore();
const agentCaseStore = new AgentCaseStore();
const adminStore = new AdminStore();
const sesamStore = new SesamStore();

export const InjectorContext = createContext(
  ReflectiveInjector.resolveAndCreate([
    { provide: GeneralStore, useValue: generalStore },
    { provide: InsightsStore, useValue: insightsStore },
    { provide: BidCaseStore, useValue: bidCaseStore },
    { provide: AgentCaseStore, useValue: agentCaseStore },
    { provide: AdminStore, useValue: adminStore },
    { provide: SesamStore, useValue: sesamStore }
  ])
);

export const useDependency = <T = any>(token: any): T =>
  useContext(InjectorContext).get(token);
